import request from '../utils/request';
import RestUrl from '../config/rest-url';

/**
 * 获取菜单项
 * @param {*} data
 * @returns
 */
export const getMenuRe = () => {
  return request.request({
    url: RestUrl.common.getMenu,
    method: 'get',
  });
};

/**
 * 获取楼盘表
 * @param {*} data
 * @returns
 */
export const getHouseListRe = (params) => {
  return request.request({
    url: RestUrl.common.queryHouseList,
    method: 'get',
    params,
  });
};

/**
 * 获取合同信息
 * @param {*} data
 * @returns
 */
export const getContractInfoByIdRe = (params) => {
  return request.request({
    url: RestUrl.common.getContractInfoById,
    method: 'get',
    params,
  });
};

/**
 * 获取数据字典
 * @param {*} query
 * @returns
 */
export function fetchItemTree(query) {
  return request.request({
    url: RestUrl.common.dictItemsByType,
    method: 'get',
    params: query,
  });
}

export const queryDictRe = (type) => {
  return fetchItemTree({ dictType: type, size: 1000 }).then((res) => {
    const setLabelFuc = (listData) => {
      listData.forEach((item) => {
        item.label = item.name;
        if (Array.isArray(item.children)) {
          setLabelFuc(item.children);
        }
      });
    };
    const rtList = res?.data || [];
    setLabelFuc(rtList);
    return rtList;
  });
};

/**
 * 获取当前登录用户信息
 */
export const getUserInfoRe = () => {
  return request.request({
    url: RestUrl.common.getUserInfo,
    method: 'get',
  });
};

/**
 * 获取可信身份认证跳转 URL
 */
export const getTrustUrlRe = () => {
  return request.request({
    url: RestUrl.common.getTrustUrl,
    method: 'get',
  });
};
